<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
        <mat-drawer
            #matDrawer
            [autoFocus]="false"
            [mode]="'side'"
            [opened]="true"
            [position]="'end'"
            class="w-72 dark:bg-gray-900">
            <!-- Demo sidebar -->
            <table-sidebar></table-sidebar>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">

            <!-- Main -->
            <div>

                <!-- Drawer toggle -->
                <!--                <button-->
                <!--                    (click)="matDrawer.toggle()"-->
                <!--                    class="mb-4"-->
                <!--                    mat-icon-button-->
                <!--                    style="margin-top: 20px; margin-left: 30px;">-->
                <!--                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>-->
                <!--                </button>-->

                <!-- Header -->
                <div
                    class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:pt-12 sm:px-10 bg-default dark:bg-transparent">
                    <div class="flex-1 min-w-0">
                        <!-- Breadcrumbs -->
                        <div>
                            <ng-content select="[breadcrumbs]"></ng-content>
                        </div>
                    </div>
                </div>

                <!-- Main -->
                <div
                    cdkScrollable
                    class="flex-auto overflow-y-auto">

                    <!-- CONTENT GOES HERE -->
                    <div>
                        <ng-content select="[content]"></ng-content>
                    </div>

                </div>

            </div>

        </mat-drawer-content>

    </mat-drawer-container>

</div>
